const E164 = /^\+[1-9]\d{1,14}$/;

/**
 * Convert a phone or fax string to E.164 for proto wire format.
 * Assumes US (+1) when no country code is present — Hinge Health is US-only;
 * if international onboarding ever lands, this util needs a country hint.
 * Throws on inputs that can't be normalized so the caller surfaces a clear error.
 */
export const phoneToE164 = (input?: string): string | undefined => {
  if (input == null) return undefined;
  const trimmed = input.trim();
  if (trimmed === '') return undefined;

  let candidate: string;
  if (trimmed.startsWith('+')) {
    candidate = `+${trimmed.slice(1).replace(/\D/g, '')}`;
  } else {
    const digits = trimmed.replace(/\D/g, '');
    if (digits.length === 10) {
      candidate = `+1${digits}`;
    } else if (digits.length === 11 && digits.startsWith('1')) {
      candidate = `+${digits}`;
    } else {
      throw new Error(
        `Invalid phone number: "${input}". Expected 10 digits, 11 digits starting with 1, or E.164 format like +15551234567.`,
      );
    }
  }

  if (!E164.test(candidate)) {
    throw new Error(
      `Invalid phone number: "${input}" normalized to "${candidate}", which is not E.164.`,
    );
  }
  return candidate;
};

export const isValidPhoneInput = (input?: string): boolean => {
  if (input == null || input.trim() === '') return true;
  try {
    phoneToE164(input);
    return true;
  } catch {
    return false;
  }
};
